import { useEffect, useState } from 'react'
import { fetchNextSteps } from 'services/guidanceService'

const FALLBACK_KEYS = ['all_clear', 'get_started', 'browse']

export const countActionable = data =>
  (data?.steps || []).filter(s => !FALLBACK_KEYS.includes(s.key)).length

const useNextSteps = (mode, enabled = true) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!enabled) { setLoading(false); return undefined }
    let live = true
    setLoading(true)
    fetchNextSteps(mode)
      .then(res => { if (live) setData(res?.data?.data || null) })
      .catch(() => {})
      .finally(() => { if (live) setLoading(false) })
    return () => { live = false }
  }, [mode, enabled])

  return { data, loading }
}

export default useNextSteps
